import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/manage_views/Home.vue'
import Main from '../views/manage_views/main.vue'
import main_home from '../components/main_home.vue'


//异步
const company = () => import('../components/accountCenter/company.vue')
const renter = () => import('../components/accountCenter/renter.vue')
const balance = () => import('../components/accountCenter/balance.vue')
const message = () => import('../components/accountCenter/message.vue')
const bank4setting = () => import('../components/accountCenter/bank4setting.vue')
const nameIDCard = () => import('../components/accountCenter/nameIDCard.vue')


const messageCenter1 = () => import('../components/accountCenter/messageCenter1.vue')
const messageCenter2 = () => import('../components/accountCenter/messageCenter2.vue')
const newslist = () => import('../components/news/newslist.vue')
const wlw_newslist = () => import('../components/news/wlw_newslist.vue')
const tyj_ptypelist = () => import('../components/news/tyj_ptypelist.vue')
const tyj_ptypelist2 = () => import('../components/news/tyj_ptypelist2.vue')
const cityManagerRule = () => import('../components/news/cityManagerRule')
const tag = () => import('../components/news/tag')

const huojianglist = () => import('../components/huojiang/huojianglist.vue')
const huojiang1 = () => import('../components/huojiang/huojiang1.vue')
const huojiang2 = () => import('../components/huojiang/huojiang2.vue')
const empty  = () => import('../components/empty.vue')
/*const wlw_cuserlist = () => import('../components/user/wlw_cuserlist.vue')
const synthesize = () => import('../components/synthesize/wlw_synthesize.vue')
const wlw_synthesizelist = () => import('../components/synthesize/wlw_synthesizelist.vue')
const picturelist = () => import('../components/picture/picturelist.vue')*/
const manageindex = () => import('../components/manage/index.vue')
const test = () => import('../components/manage/test.vue')
const menulist = () => import('../components/menu/menulist.vue')
const menulist1 = () => import('../components/menu/menulist1.vue')
const menulist2 = () => import('../components/menu/menulist2.vue')
const menulist3 = () => import('../components/menu/menulist3.vue')
const menulist4 = () => import('../components/menu/menulist4.vue')
const zonghelist = () => import('../components/zonghe/zonghelist.vue')
const huilv = () => import('../components/zonghe/huilv.vue')
const dlchanpin = () => import('../components/menu/dlchanpin.vue')
const pingbicp = () => import('../components/menu/pingbicp.vue')
const tuanduijl = () => import('../components/menu/tuanduijl.vue')
const sendmessage = () => import('../components/zonghe/sendmessage.vue')
const broadcast = () => import('../components/synthesize/broadcast.vue')
const broadcast2 = () => import('../components/synthesize/broadcast2.vue')
const broadcast_type = () => import('../components/news/broadcast_type.vue')
const banner = () => import('../components/news/banner.vue')
const banner2 = () => import('../components/news/banner2.vue')
const comment_reply = () => import('../components/news/comment_reply.vue')
const wlw_synthesizelist = () => import('../components/synthesize/wlw_synthesizelist.vue')
const wlw_synthesizelist_ad = () => import('../components/synthesize/wlw_synthesizelist_ad.vue')
const wlw_synthesizelist_pc = () => import('../components/synthesize/wlw_synthesizelist_pc.vue')
const wlw_synthesizelist_tj = () => import('../components/synthesize/wlw_synthesizelist_pc.vue')
const wlw_synthesizelist_td = () => import('../components/synthesize/wlw_synthesizelist_pc.vue')
const huifulist = () => import('../components/gzhao/huifulist.vue')
const huifu = () => import('../components/gzhao/huifu.vue')
const gzhuifu = () => import('../components/gzhao/gzhuifu.vue')
const caidan_new = () => import('../components/gzhao/caidan_new.vue')

const wlw_synthesizelist_other = () => import('../components/synthesize/wlw_synthesizelist_other.vue')
const wlw_synthesizelist_other_check = () => import('../components/synthesize/wlw_synthesizelist_other_check.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: "登录"
      }
    },
    {
      path: '/main',
      name: '主框架',
      component: Main,
      children: [
        {
          path: '/',
          name: '欢迎页面',
          component: main_home,
          meta: {
            title: "首页"
          },
        },
        {
          path: '/messageCenter1',
          name: '消息中心',
          component: newslist,
          redirect: '/messageCenter1',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/messageCenter1',
              name: '消息1',
              component: messageCenter1,
            },
            {
              path: '/messageCenter2',
              name: '消息2',
              component: messageCenter2,
            },
            {
              path: '/empty',
              name: '空页面',
              component: empty,
            }

          ]
        },
        {
          path: '/newslist',
          name: '产品管理',
          component: newslist,
          redirect: '/wlw_newslist',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/wlw_newslist',
              name: '产品发布',
              component: wlw_newslist,
            }
            , {
              path: '/tyj_ptypelist',
              name: '产品类型',
              component: tyj_ptypelist,
            }
            , {
              path: '/tyj_ptypelist2',
              name: '城市经理考核',
              component: tyj_ptypelist2,
            },
            {
              path: '/cityManagerRule',
              name: '城市经理规则',
              component: cityManagerRule,
            },
            {
              path: '/empty',
              name: '空页面',
              component: empty,
            }

          ]
        },
        {
          path: '/huojianglist',
          name: '产品管理',
          component: newslist,
          redirect: '/huojianglist',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/huojiang1',
              name: '下级奖励',
              component: huojiang1,
              props: {
                cid: 1
              }
            }
            , {
              path: '/huojiang2',
              name: '下下级奖励',
              component: huojiang1,
              props: {
                cid: 2
              }
            }
          ]
        },
        {
          path: '/huifulist',
          name: '公众号菜单',
          component: huifulist,
          redirect: '/huifu',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/huifu',
              name: '公众号自动回复',
              component: huifu,
              props: {
                cid: 1
              }
            }
            ,{
              path: '/gzhuifu',
              name: '关注自动回复',
              component: gzhuifu,
              props: {
                cid: 2
              }
            },
            {
              path: '/caidan_new',
              name: '公众号菜单',
              component: caidan_new,
              props: {
                cid: 2
              }
            }
          ]
        },
        {
          path: '/menulist',
          name: '综合管理',
          component: menulist,
          redirect: '/menulist1',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/menulist1',
              name: '订单管理',
              component: menulist1,
            },
            {
              path: '/menulist2',
              name: '客户管理',
              component: menulist2,
            },
            {
              path: '/menulist3',
              name: '提现管理',
              component: menulist3,
            },
            {
              path: '/dlchanpin',
              name: '点亮产品',
              component: dlchanpin,
            },
            {
              path: '/pingbicp',
              name: '屏蔽产品',
              component: pingbicp,
            },

            {
              path: '/tuanduijl',
              name: '团队奖励',
              component: tuanduijl,
            },
            {
              path: '/menulist4',
              name: '申请收集',
              component: menulist4,
            }
          ]
        },
        /* {
           path: '/userlist',
           name: '会员中心',
           component: newslist,
           redirect: '/wlw_userlist',
           meta: {
             requireAuth: true
           },
           children: [
             {
               path: '/wlw_userlist',
               name: '会员管理',
               component: wlw_userlist,
             }, {
               path: '/wlw_cuserlist',
               name: '企业认证',
               component: wlw_cuserlist,
             }

           ]
         },
        {
          path: '/synthesize',
          name: '栏目管理',
          component: synthesize,
          redirect: '/wlw_synthesizelist',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/picturelist',
              name: '帮助与反馈',
              component: picturelist,
              props: {
                cid: 1
              }
            },
            {
              path: '/wlw_synthesizelist1',
              name: '帮助与反馈',
              component: wlw_synthesizelist,
              props: {
                cid: 1
              }
            }, {
              path: '/wlw_synthesizelist2',
              name: '关于湾连湾',
              component: wlw_synthesizelist,
              props: {
                cid: 2
              }
            }, {
              path: '/wlw_synthesizelist3',
              name: '政策协议',
              component: wlw_synthesizelist,
              props: {
                cid: 3
              }
            }

          ]
        },*/
        {
          path: '/manageindex',
          name: '管理员中心',
          component: manageindex,
          meta: {
            requireAuth: true
          },
        },

        {
          path: '/renter',
          name: '租客管理',
          component: renter,
          meta: {
            requireAuth: true
          },
        },

        {
          path: '/balance',
          name: '结算',
          component: balance,
          meta: {
            requireAuth: true
          },
        },

        {
          path: '/nameIDCard',
          name: '姓名身份证校验',
          component: nameIDCard,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/bank4setting',
          name: '银行四要素',
          component: bank4setting,
          meta: {
            requireAuth: true
          },
        },

        {
          path: '/message',
          name: '短信充值',
          component: message,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/company',
          name: '公司信息设置',
          component: company,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/zonghelist',
          name: '其他管理',
          component: zonghelist,
          redirect: '/huilv',
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/sendmessage',
              name: '群发消息',
              component: sendmessage,
            },

            {
              path: '/huilv',
              name: '广告修改',
              component: huilv,
            },
            {
              path: '/broadcast',
              name: '消息内容管理',
              component: broadcast,
              props: {
                cid: 1
              }
            },
            {
              path: '/broadcast2',
              name: '文章管理',
              component: broadcast2,
              props: {
                cid: 1
              }
            },
            {
              path: '/broadcast_type',
              name: '消息内容类型管理',
              component: broadcast_type,
              props: {
                cid: 1
              }
            },
            {
              path: '/comment_reply',
              name: '跟帖来个梗',
              component: comment_reply,
              props: {
                cid: 1
              }
            },
            {
              path: '/banner',
              name: '轮播图管理',
              component: banner,
              props: {
                cid: 1
              }
            },
            {
              path: '/banner2',
              name: '极速查询',
              component: banner2,
              props: {
                cid: 1
              }
            },
            {
              path: '/wlw_synthesizelist',
              name: '信息发布',
              component: wlw_synthesizelist,
              props: {
                cid: 1
              }
            },
            {
              path: '/wlw_synthesizelist_ad',
              name: '广告发布',
              component: wlw_synthesizelist_ad,
              props: {
                cid: 1
              }
            },
            {
              path: '/wlw_synthesizelist_pc',
              name: ' 首页菜单管理',
              component: wlw_synthesizelist_pc,
              props: {
                cid: 2
              }
            },
            {
              path: '/wlw_synthesizelist_tj',
              name: '团队海报',
              component: wlw_synthesizelist_tj,
              props: {
                cid: 3
              }
            },
            {
              path: '/wlw_synthesizelist_td',
              name: '邀请团队图片',
              component: wlw_synthesizelist_td,
              props: {
                cid: 4
              }
            },
            {
              path: '/wlw_synthesizelist_other',
              name: '收集信息管理',
              component: wlw_synthesizelist_other,
              props: {
                cid: 4
              }
            },
            {
              path: '/wlw_synthesizelist_other_check',
              name: '收集信息查看',
              component: wlw_synthesizelist_other_check,
              props: {
                cid: 4
              }
            },
            {
              path: '/tag',
              name: '标签管理',
              component: tag,
            },



          ]
        },
        {
          path: '/test',
          name: '子账号设置',
          component: test,
          meta: {
            requireAuth: true
          },
        },
      ]

    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js